<template>
	<div @click="hideChart()">
		<div v-if="title">
			<div class="dynvibeBox">
				<div class="col-lg-12 dynvibeTitleBox">
					<h2>{{ title }}</h2>
				</div>
				<div class="col-lg-12">
					<div v-if="loading" class="dynvibeLoading"></div>
					<div v-if="!loading && noData" class="noData"><p>No Data to display</p></div>
					<dynvibechartmore
						ref="chartmore"
						v-if="!loading && !noData && type !== 'stockChart'"
						@download="downloadChart"
					></dynvibechartmore>
					<highcharts ref="highcharts" v-if="!loading && !noData" :options="chartOptions" />
				</div>
			</div>
		</div>

		<div v-if="!title" class="col-lg-12">
			<div v-if="loading" class="dynvibeLoading"></div>
			<div v-if="!loading && noData" class="noData"><p>No Data to display</p></div>
			<dynvibechartmore ref="chartmore" v-if="!loading && !noData" @download="downloadChart"></dynvibechartmore>
			<highcharts ref="highcharts" v-if="!loading && !noData" :options="chartOptions" :constructor-type="type" />
		</div>
	</div>
</template>

<script>
import dynvibechartmore from "@/components/vueCharts/DynvibeChartMore.vue";
export default {
	name: "dynvibebasechart",
	emits: ["created"],
	//mixins: [mixin],
	props: {
		functionClick: {
			type: Function,
			default() {
				return "Default function";
			},
		},
		title: {
			type: String,
			default: () => "",
		},
		type: {
			type: String,
			default: () => "chart",
		},
	},
	components: {
		dynvibechartmore: dynvibechartmore,
	},
	mounted() {
		this.$emit("created");
	},
	data() {
		return {
			loading: true,
			noData: false,
			chartOptions: {
				chart: { type: "bar" },
				title: { text: "" },
				xAxis: {
					title: { text: "" },
					categories: [],
					minorGridLineWidth: 0,
					gridLineWidth: 0,
					lineWidth: 2,
					lineColor: "#C9C9C9",
					tickWidth: 0,
					labels: {
						style: {
							"font-family": "Intro, Arial, Helvetica, sans-serif",
							"font-size": "14px",
							"font-weight": "400",
							"text-transform": "uppercase",
							color: "#7C7C7C",
						},
					},
				},
				yAxis: {
					title: { text: "" },
					minorGridLineWidth: 0,
					gridLineWidth: 0,
					lineWidth: 2,
					lineColor: "#C9C9C9",
					tickWidth: 0,
					labels: {
						style: {
							"font-family": "Intro, Arial, Helvetica, sans-serif",
							"font-size": "14px",
							"font-weight": "400",
							"text-transform": "uppercase",
							color: "#7C7C7C",
						},
					},
				},
				credits: { enabled: false },
				exporting: {
					enabled: false,
					/*buttons: {
					  contextButton: {
						menuClassName: "dynvibeChartMore",
						symbol: "menuball",
						symbolSize: 10,
						x: 20,
						symbolFill: '#aaa',
						symbolStroke: "#aaa",
						menuItems: ['printChart', 'downloadAs', 'separator', 'downloadPNG', 'downloadJPEG', "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
					  }
					}*/
				},
				legend: {
					reversed: true,
					itemStyle: {
						"font-family": "Intro, Arial, Helvetica, sans-serif",
						"font-size": "14px",
						"font-weight": "400",
						"text-transform": "uppercase",
						color: "#7C7C7C",
					},
				},
				series: [],
				plotOptions: {
					bar: {
						cursor: "pointer",
					},
					series: {
						cursor: "pointer",
						events: {
							click: this.functionClick,
						},
					},
				},
			},
		};
	},
	methods: {
		hideChart() {
			if (this.$props.type !== "stockChart" && !this.noData) {
				this.$refs.chartmore.showMore = false;
			}
		},
		getChartOptions() {
			return this.chartOptions;
		},
		updateChartOptions(newChartOptions) {
			this.chartOptions = newChartOptions;
		},
		setLoading(bool) {
			this.loading = bool;
		},
		setNoData(bool) {
			this.noData = bool;
		},
		setVisible() {
			if (typeof this.$refs.highcharts !== "undefined" && this.$refs.highcharts !== null) {
				for (let i = 0; i < this.$refs.highcharts.chart.series.length; i++) {
					this.$refs.highcharts.chart.series[i].setVisible(true, false);
				}
			}
		},
		reflow() {
			if (!this.noData) {
				this.$refs.highcharts.chart.reflow();
			}
		},
		resetXAxis() {
			if (this.$refs.highcharts && this.$refs.highcharts.chart) {
				this.$refs.highcharts.chart.xAxis[0].setExtremes(null, null, true);
			}
		},
		downloadChart(downloadType) {
			if (downloadType === "print") this.$refs.highcharts.chart.print();
			else if (downloadType === "CSV") this.$refs.highcharts.chart.downloadCSV();
			else if (downloadType === "PNG") this.$refs.highcharts.chart.exportChart();
			else if (downloadType === "JPEG") this.$refs.highcharts.chart.exportChart({ type: "image/jpeg" });
			else if (downloadType === "PDF") this.$refs.highcharts.chart.exportChart({ type: "application/pdf" });
			else if (downloadType === "SVG") this.$refs.highcharts.chart.exportChart({ type: "image/svg+xml" });
			else if (downloadType === "XLS") this.$refs.highcharts.chart.downloadXLS();
		},
	},
};
</script>

<style></style>
